// components/AI/useSlashCommands.js
// Slash command diproses LOKAL — tidak pernah dikirim ke AI/server.
// Dipisah dari sendMessage supaya alur kirim yang sesungguhnya tidak lagi
// diselingi 60 baris penanganan perintah.
//
// Kontrak: handle(userText) mengembalikan `true` bila teks tsb adalah slash
// command dan sudah ditangani — pemanggil harus berhenti di situ. `false`
// berarti bukan command, lanjutkan kirim seperti biasa.
import { useCallback } from 'react';

export function useSlashCommands({
  t, messages, quickPrompts, sessionIdRef, genSessionId,
  setMessages, setInput, setShowPrompts, setActiveKeyInfo,
  setProactiveToast, setServerRowCount, onAutoDetect,
}) {
  return useCallback((userText) => {
    if (!userText.startsWith('/')) return false;

    const cmd = userText.slice(1).trim().toLowerCase().split(/\s+/)[0];
    if (cmd === 'agent') return false; // /agent -> backend (Agent SDK)
    const sysMsg = (content) => setMessages(prev => [...prev, { role: 'system-note', content }]);

    // /clear /new /reset — reset sesi (ganti session_id → konteks benar-benar bersih)
    if (cmd === 'clear' || cmd === 'new' || cmd === 'reset') {
      setMessages([]);
      setShowPrompts(true);
      sessionIdRef.current = genSessionId();
      setActiveKeyInfo({ index: 1, count: 1 });
      setProactiveToast(null);
      setServerRowCount(null);
      setInput('');
      onAutoDetect?.('');   // balikkan selector "Analisis data" ke General (no-op di AIPanel)
      return true;
    }

    // /help — daftar command
    if (cmd === 'help') {
      setInput('');
      sysMsg(t('ai.cmdHelp'));
      return true;
    }

    // /sql — tampilkan SQL dari jawaban data terakhir
    if (cmd === 'sql') {
      setInput('');
      const lastSql = [...messages].reverse()
        .find(m => m.role === 'assistant' && m.aiServiceSql)?.aiServiceSql;
      sysMsg(lastSql
        ? t('ai.cmdSqlLabel') + '\n```sql\n' + lastSql + '\n```'
        : t('ai.cmdNoSql'));
      return true;
    }

    // /examples — tampilkan contoh pertanyaan
    if (cmd === 'examples') {
      setInput('');
      if (quickPrompts && quickPrompts.length) {
        sysMsg(t('ai.cmdExamples') + '\n' + quickPrompts.map(q => `- ${q}`).join('\n'));
      } else {
        setShowPrompts(true);
        sysMsg(t('ai.cmdNoExamples'));
      }
      return true;
    }

    // Command tak dikenal → beri tahu, JANGAN kirim ke AI.
    setInput('');
    sysMsg(`${t('ai.cmdUnknownPre')} \`/${cmd}\` ${t('ai.cmdUnknownPost')}`);
    return true;
  }, [
    t, messages, quickPrompts, sessionIdRef, genSessionId,
    setMessages, setInput, setShowPrompts, setActiveKeyInfo,
    setProactiveToast, setServerRowCount, onAutoDetect,
  ]);
}
